import { api } from "../App";
import { createNotification } from "../components/Notifications/Notifications";
import {
  SET_EQUIPMENT_LIST,
  SET_EQUIPMENT_LOADING,
  SET_EQUIPMENT_CARD,
  SET_EQUIPMENT_LOOKUPS,
  SET_EQUIPMENT_FILTERS,
  SET_EQUIPMENT_FILES,
} from "./types";


// GET /equipment — список (limit/offset/mid/rid/search)
export const getEquipmentList = (params) => async (dispatch) => {
  dispatch({ type: SET_EQUIPMENT_LOADING, payload: true });
  try {
    const { data } = await api.get('/equipment', { params });
    dispatch({ type: SET_EQUIPMENT_LIST, payload: data });
  } catch (ERR) {
    createNotification('error', 'Не удалось загрузить список оборудования');
  } finally {
    dispatch({ type: SET_EQUIPMENT_LOADING, payload: false });
  }
}

// GET /equipment/{id} — карточка
export const getEquipmentCard = (id) => async (dispatch) => {
  try {
    const { data } = await api.get(`/equipment/${id}`);
    dispatch({ type: SET_EQUIPMENT_CARD, payload: data });
    return data;
  } catch (ERR) {
    createNotification('error', 'Не удалось загрузить карточку');
    return null;
  }
}

export const clearEquipmentCard = () => ({ type: SET_EQUIPMENT_CARD, payload: null })

export const clearEquipmentFiles = () => ({ type: SET_EQUIPMENT_FILES, payload: [] })

export const createEquipment = (reqData) => async () => {
  try {
    const { data } = await api.post('/equipment', reqData);
    createNotification('success', 'Запись добавлена');
    return data;
  } catch (error) {
    createNotification('error', error.response?.data?.detail || 'Не удалось создать запись');
    return null;
  }
}

export const updateEquipment = (id, reqData) => async () => {
  try {
    const { data } = await api.put(`/equipment/${id}`, reqData);
    createNotification('success', 'Изменения сохранены');
    return data;
  } catch (error) {
    createNotification('error', error.response?.data?.detail || 'Не удалось изменить запись');
    return null;
  }
}

export const deleteEquipment = (id) => async () => {
  try {
    await api.delete(`/equipment/${id}`);
    createNotification('success', 'Запись удалена');
    return true;
  } catch (error) {
    createNotification('error', error.response?.data?.detail || 'Ошибка удаления');
    return false;
  }
}

// Справочники карточки: группы, помещения, ответственные, distinct-значения автодополнения
export const getEquipmentLookups = (currentMid) => async (dispatch) => {
  try {
    const [groups, rooms, responsible, edizm, equiptype, status] = await Promise.all([
      api.get('/equipment/lookups/groups'),
      api.get('/equipment/lookups/rooms'),
      api.get('/equipment/lookups/responsible', { params: currentMid ? { current_mid: currentMid } : {} }),
      api.get('/equipment/lookups/distinct/edizm'),
      api.get('/equipment/lookups/distinct/equiptype'),
      api.get('/equipment/lookups/distinct/status'),
    ]);
    dispatch({
      type: SET_EQUIPMENT_LOOKUPS,
      payload: {
        groups: groups.data.data,
        rooms: rooms.data.data,
        responsible: responsible.data.data,
        edizm: edizm.data.data,
        equiptype: equiptype.data.data,
        status: status.data.data,
      },
    });
  } catch (ERR) {
  }
}

// Значения фильтров шапки списка
export const getEquipmentFilters = () => async (dispatch) => {
  try {
    const [responsible, rooms] = await Promise.all([
      api.get('/equipment/filters/responsible'),
      api.get('/equipment/filters/rooms'),
    ]);
    dispatch({
      type: SET_EQUIPMENT_FILTERS,
      payload: { responsible: responsible.data.data, rooms: rooms.data.data },
    });
  } catch (ERR) {
  }
}

// ФОТО

export const getEquipmentPhoto = (id) => async () => {
  try {
    const { data } = await api.get(`/equipment/${id}/photo`, { responseType: 'blob' });
    return data;
  } catch (ERR) {
    return null;
  }
}

export const uploadEquipmentPhoto = (id, file) => async () => {
  try {
    const formData = new FormData();
    formData.append('photo', file);
    await api.post(`/equipment/${id}/photo`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    createNotification('success', 'Фото сохранено');
    return true;
  } catch (error) {
    createNotification('error', error.response?.data?.detail || 'Ошибка загрузки фото');
    return false;
  }
}

export const deleteEquipmentPhoto = (id) => async () => {
  try {
    await api.delete(`/equipment/${id}/photo`);
    createNotification('success', 'Фото удалено');
    return true;
  } catch (error) {
    createNotification('error', error.response?.data?.detail || 'Ошибка удаления фото');
    return false;
  }
}

// ФАЙЛЫ

export const getEquipmentFiles = (id) => async (dispatch) => {
  try {
    const { data } = await api.get(`/equipment/${id}/file`);
    dispatch({ type: SET_EQUIPMENT_FILES, payload: data });
  } catch (ERR) {
    dispatch({ type: SET_EQUIPMENT_FILES, payload: [] });
  }
}

export const uploadEquipmentFiles = (id, files) => async (dispatch) => {
  try {
    for (const file of files) {
      const formData = new FormData();
      formData.append('file', file);
      await api.post(`/equipment/${id}/file`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
    createNotification('success', files.length > 1 ? 'Файлы загружены' : 'Файл загружен');
  } catch (error) {
    createNotification('error', error.response?.data?.detail || 'Ошибка загрузки файла');
  } finally {
    await dispatch(getEquipmentFiles(id));
  }
}

export const downloadEquipmentFile = (id, fileName) => async () => {
  try {
    const { data } = await api.get(`/equipment/${id}/file/${encodeURIComponent(fileName)}`, {
      responseType: 'blob',
    });
    return data;
  } catch (ERR) {
    createNotification('error', 'Ошибка скачивания файла');
    return null;
  }
}

export const deleteEquipmentFile = (id, fileName) => async (dispatch) => {
  try {
    await api.delete(`/equipment/${id}/file/${encodeURIComponent(fileName)}`);
    createNotification('success', 'Файл удалён');
    await dispatch(getEquipmentFiles(id));
  } catch (error) {
    createNotification('error', error.response?.data?.detail || 'Ошибка удаления файла');
  }
}
